import { Timestamp } from "firebase/firestore";

// What's being reported - kept for parity with the iOS app's ReportType.
export enum ModelReportType {
  MEMORIAL = 0,
  TRIBUTE = 1,
}

export enum ModelReportStatus {
  OPEN = 0,
  // Dismissed by the memorial's own owner/manager - still visible to super
  // admins, never deleted, so there's always an audit trail.
  DISMISSED = 1,
  // The memorial admin escalated it to the RememQR team for a closer look.
  CONTACTED_SUPPORT = 2,
  // Closed out by a super admin.
  RESOLVED = 3,
}

// Stored at public/{memorialId}/reports/{reportId} - one document per
// report (rather than the old single upsert-per-target counter doc) so
// each report can carry its own status and nothing is ever overwritten.
export interface ModelReport {
  id?: string;
  memorial_id: string;
  type: ModelReportType;
  tribute_id?: string;
  comment?: string;
  status: ModelReportStatus;
  // Auth uid at the time of reporting, if the reporter was signed in.
  reporter_id?: string;
  created: Timestamp;
  updated: Timestamp;
}
